import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/auth/SessionAuthInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/auth/SessionMonitor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/common/AutomaticUpdateManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/layout/GlobalNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalErrorHandler"] */ "/vercel/path0/app/components/utils/NextJSErrorHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UnifiedErrorBoundary"] */ "/vercel/path0/app/components/utils/UnifiedErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccentColorProvider"] */ "/vercel/path0/app/contexts/AccentColorContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AllocationIncrementProvider"] */ "/vercel/path0/app/contexts/AllocationIncrementContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AllocationIntervalProvider"] */ "/vercel/path0/app/contexts/AllocationIntervalContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DateFormatProvider"] */ "/vercel/path0/app/contexts/DateFormatContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DemoBalanceProvider"] */ "/vercel/path0/app/contexts/DemoBalanceContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EarningsProvider"] */ "/vercel/path0/app/contexts/EarningsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LineSettingsProvider"] */ "/vercel/path0/app/contexts/LineSettingsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationOrderProvider"] */ "/vercel/path0/app/contexts/NavigationOrderContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PillStyleProvider"] */ "/vercel/path0/app/contexts/PillStyleContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecentPagesProvider"] */ "/vercel/path0/app/contexts/RecentPagesContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubscriptionProvider"] */ "/vercel/path0/app/contexts/SubscriptionContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UsdBalanceProvider"] */ "/vercel/path0/app/contexts/UsdBalanceContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/app/providers/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DataProvider"] */ "/vercel/path0/app/providers/DataProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogRocketProvider"] */ "/vercel/path0/app/providers/LogRocketProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileProvider"] */ "/vercel/path0/app/providers/MobileProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/vercel/path0/app/providers/NotificationProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PWAProvider"] */ "/vercel/path0/app/providers/PWAProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReactQueryProvider"] */ "/vercel/path0/app/providers/ReactQueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/app/providers/ThemeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/utils/detailedErrorLogging.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/utils/developmentErrorOverride.ts");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/.pnpm/@vercel+speed-insights@1.2.0_next@15.4.7_@babel+core@7.28.0_@opentelemetry+api@1.9.0_babel-pl_fmdp2rq6542dkulixxwwlqlxza/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/leaflet@1.9.4/node_modules/leaflet/dist/leaflet.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.4.7_@babel+core@7.28.0_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react-dom@1_fjh5wb34q77h2i547pw6qabv5y/node_modules/next/dist/client/script.js");
